class BannerExpanding {
  constructor(container, animationSpeed = 300) {
    this.container = container;
    this.toggleButton = container.querySelector('.banner-expanding--toggle');
    this.panel = container.querySelector('.banner-expanding-panel');
    this.animationSpeed = animationSpeed;

    if (this.toggleButton && this.panel) {
      this.setupAccessibility();

      this.toggleButton.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        this.toggle();
      });

      this.toggleButton.addEventListener('keydown', (e) => this.handleKeydown(e));
    }
  }

  setupAccessibility() {
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.setAttribute('aria-controls', this.panel.id || this.generateId(this.panel));
    this.panel.setAttribute('aria-hidden', 'true');

    if (!this.toggleButton.hasAttribute('role')) {
      this.toggleButton.setAttribute('role', 'button');
    }

    if (!this.panel.id) {
      this.panel.id = this.generateId(this.panel);
    }
  }

  generateId(element) {
    return 'banner-' + Math.random().toString(36).substr(2, 9);
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggle();
    }
  }

  toggle() {
    const isOpen = this.container.classList.contains('banner-open');

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.container.classList.add('banner-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.panel.setAttribute('aria-hidden', 'false');
    this.toggleButton.querySelector('span').classList.add('is-hidden');
    this.toggleButton.querySelector('span.is-hidden').classList.remove('is-hidden');
    this.slideDown(this.panel);
  }

  close() {
    this.container.classList.remove('banner-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
    this.toggleButton.querySelector('span').classList.remove('is-hidden');
    this.toggleButton.querySelector('span.is-hidden').classList.add('is-hidden');
    this.slideUp(this.panel);
  }

  slideDown(element) {
    element.style.height = '0px';
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.transition = `height ${this.animationSpeed}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });
    setTimeout(() => {
      element.style.height = '';
      element.style.transition = '';
    }, this.animationSpeed);
  }

  slideUp(element) {
    const height = element.scrollHeight;
    element.style.height = `${height}px`;
    element.style.transition = `height ${this.animationSpeed}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = '0px';
    });
    setTimeout(() => {
      element.style.display = 'none';
      element.style.height = '';
      element.style.transition = '';
    }, this.animationSpeed);
  }
}

export {BannerExpanding};